import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c389ee5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader-screen" }
const _hoisted_2 = {
  key: 1,
  class: "reload-screen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Кажется, что-то пошло не так. Пожалуйста, убедитесь, что у вас выключен VPN и нажмите на кнопку ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_LetoButton = _resolveComponent("LetoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!this.waitingTooMuch)
      ? (_openBlock(), _createBlock(_component_PreLoader, { key: 0 }))
      : _createCommentVNode("", true),
    (this.waitingTooMuch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_LetoButton, {
            btnVerySmall: true,
            text: "Перезапустить",
            onClick: $options.reload
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}